<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header
      :show-go-back="true"
      :title="'Fund transfer'"
    />

    <main class="scrollable container">
      <!-- Send money to -->
      <section :style="{marginBottom: '30px'}">
        <span
          :class="'t14'"
          :style="{marginBottom: '10px', display: 'block'}"
          >Send money to</span
        >
        <div
          :class="'row-center'"
          :style="{gap: '14px'}"
        >
          <img
            alt="avatar"
            src="https://george-fx.github.io/apitex_api/assets/users/02.png"
            :style="{width: '30px', height: '30px', borderRadius: '50%'}"
          />
          <h5 :style="{marginRight: 'auto'}">Jazmine Goodwin</h5>
          <span :class="'t14'">**** 1258</span>
        </div>
      </section>

      <!-- Use card -->
      <section>
        <ul :style="{marginBottom: '10px'}">
          <li
            v-for="(card, index) in cards"
            :key="card.id"
            :style="{
              gap: '12px',
              padding: '12px',
              borderRadius: '10px',
              border: `1px solid ${
                card.id === selectedCard ? '#6C6D84' : '#FFEFE6'
              }`,
              marginBottom: index === cards.length - 1 ? '0' : '10px',
              backgroundColor: 'var(--white-color)',
            }"
            :class="'row-center clickable'"
            @click="selectCard(card.id)"
          >
            <img
              :src="card.image"
              :style="{width: '62px', borderRadius: '6px'}"
            />
            <div :style="{display: 'flex', flexDirection: 'column'}">
              <span
                class="'t12'"
                :style="{color: 'var(--text-color)'}"
                >{{ card.number }}</span
              >
              <span class="'t12'">{{ card.balance }} USD</span>
            </div>
          </li>
        </ul>
        <Input
          :leftIcon="DollarSvg"
          :placeholder="'Amount'"
          :containerStyle="{marginBottom: '10px'}"
        />
        <textarea
          :style="{
            marginBottom: '10%',
            width: '100%',
            height: '120px',
            borderRadius: '10px',
            fontSize: '16px',
            border: '1px solid #FFEFE6',
            paddingLeft: '20px',
            paddingTop: '14px',
            resize: 'none',
          }"
          placeholder="Comment"
        ></textarea>
        <span
          :class="'t14'"
          :style="{marginBottom: '30px', display: 'block'}"
          >Bank fee: 0.20 USD</span
        >
      </section>

      <!-- Button -->
      <section>
        <Button
          :title="'Send'"
          @click="$router.push(routes.PAYMENT_SUCCESS)"
          :containerStyle="{marginBottom: '20px'}"
        />
      </section>
    </main>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import {useOpacity} from '@/hooks';
import {Input} from '@/components';
import {Header} from '@/components';
import {Button} from '@/components';
import {Background} from '@/components';
import {DollarSvg} from '@/assets/svg';

import {routes} from '@/routes';

const opacity = useOpacity();

const cards = [
  {
    id: 1,
    type: 'Visa',
    balance: '4 863.27',
    number: '**** **** **** 7895',
    image: require('@/assets/cards/01.jpg'),
  },
  {
    id: 2,
    type: 'Mastercard',
    balance: '1 234.56',
    number: '**** **** **** 1234',
    image: require('@/assets/cards/02.jpg'),
  },
];

const selectedCard = ref(cards[0].id);

const selectCard = (id) => {
  selectedCard.value = id;
};
</script>
